module.exports = __webpack_public_path__ + "static/media/button_notification.8e07422c.svg";